import React from 'react'
import { Redirect } from 'react-router-dom'

const Login = () => <Redirect to="/" />

export default Login
